module.exports = __webpack_public_path__ + "static/media/ensina-banner-materno-site-02.522cb66d.png";